<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/ygjc-product.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>阳光驾乘人员意外险</h2>
					<div style="color: red">货车、特种车驾意险 | 全线上操作</div>
					<p>
						① 投保简便，可保特种车
						<br />
						② 社保用药免赔100元后100%赔付
						<br />
						③ 跟车不跟人，最高可保100万
						<br />
					</p>
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
					<br />
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<!-- <template slot="header">
            <el-alert
              type="warning"
              show-icon
              title="提示：钢结构是三个工种的统称，三个工种分别是：钢结构安装工/钢骨结构工人/钢架架设工人。"
              :closable="false"
            ></el-alert>
          </template> -->

					<avue-crud
						ref="plan"
						:cell-style="onCellStyle"
						:data="dataPlan"
						:option="optionPlan"
						:span-method="spanMethodPlan"></avue-crud>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="qa in dataQA" :key="qa.question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ qa.question }}</span>
								</div>
								<p></p>
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<span style="white-space: pre-wrap">{{ qa.answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<h3>保险条款及须知</h3>
						<p style="line-height: 32px">
							1、本保险适用以下保险条款：
							<br />
							2、本保险由阳光财产保险股份有限公司承保，承保区域为全国范围（港澳台除外）。
							<br />
							3、保险公司全国统一的客户服务及投诉方式详见如下链接：
							<br />
							<span class="link">
								<a href="https://wecare.sinosig.com/" style="color: DodgerBlue" target="_blank">
									全国统一的客户服务及投诉方式
								</a>
							</span>
							4、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
							<br />
							5、
							<span class="red-bold">
								在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
							</span>
							<br />
							6、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
							<br />
							7、本保险根据投保单位的需求提供电子发票或纸质专票。
							<br />
							8、
							<span class="red-bold">
								本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。
							</span>
							<br />
						</p>
						<el-divider></el-divider>
						<h3>特别约定</h3>
						<p style="line-height: 32px">
							1、特定团体是指法人、非法人组织以及其他不以购买保险为目的而组成的团体。特定团体属于法人或非法人组织的，投保人应为该法人或非法人组织；特定团体属于其他不以购买保险为目的而组成的团体的，该特定团体中对被保险人具有保险利益的机动车辆所有人和管理人可作为投保人。
							<br />
							2、
							<span class="red-bold">
								被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，免赔50%。
							</span>
							如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							<br />

							3、
							<span class="red-bold">
								出险后，被保险人必须在72小时内拨打95510取得报案号后才是报案成功（否则报案失败）。如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第2条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							<br />
							4、若
							<span class="red-bold">出险时为交通事故，索赔时须提供公安部门出具的证明</span>
							（列明当事人、出险时间、地点、原因及经过等事故信息）
							<span class="red-bold">或交警部门出具的事故责任认定书，发生交通事故需先行车险理赔，</span>
							若
							<span class="red-bold">上述材料未提供或提供信息不完整的案件，保险人有权予以拒赔。</span>
							<br />
							5、每车仅能投保一种方案，限投一份，多投无效。
							<br />
							6、本保单
							<span class="red-bold">不保装卸车，本保单</span>
							所指机动车辆为货车、专用车，专用车为用于清障、清扫、清洁、起重、升降、挖掘、推土和保温用途等装载有专用设备、仪器与器具，具有专项用途的车辆。
							<br />
							7、出险时，车辆实际载人数与核定载人数不一致时，按车辆实际载人数进行赔付。车辆实际载人数小于或等于核定载人数，各保障项目的每人保险金额限额为每座保额；出险时若车辆实际载人数大于核定载人数，各保障项目的每人保险金额为：车辆总保险金额/实际载人数。
							<br />
							8、出险时，
							<span class="red-bold">
								若车辆载物大于核定载质量50%以上的，保险人对按保单规定的应承担的保险责任，免赔50%；若车辆载物大于核定载质量30%以上未达50%，保险人对按保单规定的应承担的保险责任，免赔30%。
							</span>
							<br />
							9、保险期间内，被保险人在乘坐或驾驶保险单中载明的机动车辆行驶过程中或为维护车辆继续运行（包括加油、加水、故障修理、换胎等）的临时停放过程中或作业中（
							<span class="red-bold">除外装卸作业责任</span>
							），因遭受意外伤害事故导致身故、残疾的，保险人依照下列约定给付保险金，且给付各项保险金之和不超过意外伤害保险金额。
							<br />
							10、对于医疗费用：保险人按投保人营业执照注册地（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。社保行政部门公布的城镇职工医疗保险的范围及标准赔付。保险期间届满被保险人治疗仍未结束的，保险人继续承担给付保险金责任，
							<span class="red-bold">
								自保险期间届满30日内（含第30日）且最长不超过该次意外伤害事故发生之日起180日的医疗费用承担保险金给付责任。
							</span>
							<br />
							11、对于住院津贴：按100元/天/座进行赔偿，每次事故赔偿不超过90天，累计不超过180天，无免赔。（
							<span class="red-bold">
								但最长延续至本附加险保险期间届满日后第 30 日，且保险人对该次住院累计给付住院津贴的日数不超过 90 日
							</span>
							）
							<br />
							12、
							<span class="red-bold">
								本保单不承担车辆及车上任何货物损失，不承担由于职业病或任何性质的精神损害赔偿责任。不承保装卸工与不承担车上人员装卸作业事故责任
							</span>
							<br />
							13、本保单被保险人意外伤害残疾以《人身保险伤残评定标准》(标准编号为JR/T0083－2013）所列残疾标准的对应比例进行赔付。《人身保险伤残评定标准》对功能和残疾进行了分类和分级，将人身保险伤残程度划分为一至十级，经司法鉴定后，伤残按一级100%、二级90%、三级80%、四级70%、五级60%、六级50%、七级40%、八级30%、九级20%、十级10%的比例赔付。如自该意外伤害事故发生之日起第180日治疗仍未结束，按第180日的身体情况进行残疾鉴定，并据此给付残疾保险金。
							<br />
							14、
							<span class="red-bold">
								车辆驾驶员或操作员需持国家有关部门核发的有效操作证，否则保险人对按保单规定的应承担的保险责任，免赔20%，若车辆驾驶员驾驶证无效或车辆行驶证无效，则保险人不承担保险责任。
							</span>
							<br />
							15、高处作业以《高处作业分级标准》（中华人民共和国国家标准GB3608-2008）中的定义为准。
							<span class="red-bold">
								从事高处作业须系安全带，且须持有有效的特种作业操作证（高处作业），否则保险人对按保单规定的应承担的保险责任，免赔20%。
							</span>
							<br />
							16、本保单指定就诊医院为
							<span class="red-bold">大陆境内二级及以上公立医院，</span>
							但
							<span class="red-bold">
								不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市。
							</span>
							如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。
							<span class="red-bold">
								对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。
							</span>
							<br />
							17、（若扩展猝死责任）在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡（
							<span class="red-bold">
								雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内
							</span>
							），保险人承担赔偿责任。
							<br />
							18、意外伤害医疗免赔额为100元，给付比例为100%。
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {currentYYYYmmdd} from '@/util/date'
import {handleDownCategoryFile} from '@/util/util'
import {optionPlanYgjc} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product45Details',
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data: function () {
		return {
			currentStep: '0',
			optionPlan: this.deepClone(optionPlanYgjc),

			priceRate: 1,
			priceRateList: [
				{
					label: '1档',
					value: 1,
				},
				{
					label: '2档',
					value: 2,
				},
			],
			kuozhanRate: 1,
			kuozhanRateList: [
				{
					label: '否',
					value: 1,
				},
				{
					label: '是',
					value: 2,
				},
			],
			dataPlan: [],
			dataPlanTemp: [
				{
					insuredItem: '死亡/伤残保额',
					plan1: '10万/座',
					plan2: '30万/座',
					plan3: '50万/座',
					plan4: '100万/座',
				},
				{
					insuredItem: '医疗保额',
					plan1: '1万/座',
					plan2: '3万/座',
					plan3: '5万/座',
					plan4: '10万/座',
				},
				{
					insuredItem: '住院津贴',
					plan1: '100元/天/座',
				},
				{
					insuredItem: '医疗免赔',
					plan1: '100元免赔，100%给付',
				},
				// {
				//     insuredItem: "是否扩展猝死责任",
				//     plan1: "是",
				//     plan2: "否"
				// },
				{
					insuredItem: '不扩展猝死责任',
					plan1:
						'本保单不扩展被保险人猝死责任，因猝死原因造成本保险合同被保险人身故、残疾的，保险人不承担给付保险金责任。',
				},
			],
			priceData1: [
				{
					insuredItem: '3座车及以下：元',
					plan1: 270,
					plan2: 600,
					plan3: 1050,
					plan4: 2250,
				},
				{
					insuredItem: '4座车：元',
					plan1: 360,
					plan2: 800,
					plan3: 1400,
					plan4: 3000,
				},
				{
					insuredItem: '5座车：元',
					plan1: 450,
					plan2: 1000,
					plan3: 1750,
					plan4: 3750,
				},
				// {
				//     insuredItem: "附加扩展猝死责任",
				//     plan1:
				//         "本保单扩展被保险人在乘坐或驾驶保险单中载明的机动车辆行驶过程中或为维护车辆继续运行（包括加油、加水、故障修理、换胎等）的临时停放过程中或作业中突发疾病死亡或者在48小时之内经抢救无效死亡。"
				// },
				//
				// {
				//     insuredItem: "猝死死亡保额",
				//     plan1: "10万/座",
				//     plan2: "30万/座",
				//     plan3: "50万/座",
				//     plan4: "100万/座"
				// },
				// {
				//     insuredItem: "3座车及以下：元",
				//     plan1: 297,
				//     plan2: 660,
				//     plan3: 1155,
				//     plan4: 2475
				// },
				// {
				//     insuredItem: "4座车：元",
				//     plan1: 396,
				//     plan2: 880,
				//     plan3: 1540,
				//     plan4: 3300
				// },
				// {
				//     insuredItem: "5座车：元",
				//     plan1: 495,
				//     plan2: 1100,
				//     plan3: 1925,
				//     plan4: 4125
				// }
			],

			dataQA: [
				{
					question: '该保险方案的承保保险公司是？',
					answer:
						'阳光财产保险股份有限公司（以下简称“阳光财险”）成立于2005年7月28日，是阳光保险集团股份有限公司旗下的全国性专业财险公司，注册资本金57.46亿元。目前已有36家二级机构开业运营，三四级分支机构超1800家，服务网络实现全国覆盖。',
				},
				{
					question: '该保险方案中，哪些单位可作为投保人？',
					answer: '对被保险人具有保险利益的机动车辆所有人和管理人可作为投保人。',
				},
				{
					question: '该保险方案中，哪些人员可作为被保险人？',
					answer: '凡驾驶或乘坐机动车辆，且身体健康、能正常工作或正常生活的自然人均可作为被保险人。',
				},
				{
					question: '该保险方案是否可以保高处作业？',
					answer:
						'本保险方案可以保高处作业，高处作业以《高处作业分级标准》（中华人民共和国国家标准GB3608-2008）中的定义为准。从事高处作业须系安全带，且须持有有效的特种作业操作证（高处作业），否则保险人对按保单规定的应承担的保险责任，免赔20%。',
				},
				{
					question: '该保险方案责任范围包括哪些？',
					answer:
						'该保险方案责任包括以下四种情况：\n' +
						'（一）在保险期间内，被保险人驾驶或乘坐机动车辆，在自进入车厢时起至离开车厢时止的整个车辆行驶期间，因遭受意外伤害事故，并且自该事故发生之日起 180 日内因该事故身故的；\n' +
						'（二）或因遭受该意外伤害事故，并自该事故发生之日起 180 日内因该事故为直接原因造成《人身保险伤残评定标准及代码》所列残疾之一的；\n' +
						'（三）或因遭受主险合同保险责任范围内的意外伤害事故需在医院进行治疗的；\n' +
						'（四）或因以该次意外伤害事故为直接原因导致伤害，需到医院接受住院治疗的；',
				},
				{
					question: '本保险方案承保哪些车辆？',
					answer:
						'本保单不保装卸车，本保单所指机动车辆为货车、专用车，专用车为用于清障、清扫、清洁、起重、升降、挖掘、推土和保温用途等装载有专用设备、仪器与器具，具有专项用途的车辆',
				},
				{
					question: '怎么投保？怎么支付？',
					answer: '直接用电脑在此网页上操作即可，无需任何纸质资料，具体流程：选方案→填信息→线上支付保费→获取保单。',
				},
				{
					question: '保单和发票怎么获取？',
					answer: '线上投保完成后实时出具电子保单，如果客户选择普票则实时出具电子普票，如果选择专票则通过快递寄送。',
				},
			],
			isDownLoading: false,
		}
	},
	mounted() {
		this.dealPrice()
	},
	methods: {
		//处理钱
		dealPrice() {
			let tempCenter1 = {
				insuredItem: '是否扩展伤残赔偿比例十级标准',
			}
			let tempCenter = {}
			if (this.kuozhanRate === 1) {
				tempCenter1.plan1 = '否'
				tempCenter = {
					insuredItem: '不扩展伤残赔偿比例十级标准',
					plan1:
						'本保单按国家社保《职工工伤与职业病致残程度鉴定标准》（GB/T 16180-2014）进行伤残等级鉴定，给付比例一级到十级分别为：100%，80%，70%，60%，50%，40%，30%，20%，10%，5%',
				}
			} else {
				tempCenter1.plan1 = '是'
				tempCenter = {
					insuredItem: '扩展伤残赔偿比例十级标准',
					plan1:
						'本保单按国家社保《职工工伤与职业病致残程度鉴定标准》（GB/T 16180-2014）进行伤残等级鉴定，给付比例一级到十级分别为：100%，80%，70%，60%，50%，40%，30%，25%，15%，10%；',
				}
			}
			let tempData = this.deepClone(this.dataPlanTemp)
			// tempData.push(tempCenter1)
			// tempData.push(tempCenter)
			//处理钱
			let tempPrice = this.priceRate === 1 ? this.deepClone(this.priceData1) : this.deepClone(this.priceData2)
			//扩展了 要乘以 1.1
			// let tempKuozhanRate = this.kuozhanRate === 2 ? 1.1 : 1;

			// tempPrice.forEach((itemData) => {
			//   for (let i = 1; i <= 8; i++) {
			//     itemData[`plan${i}`] = itemData[`plan${i}`] * tempKuozhanRate;
			//   }
			// });
			tempData = tempData.concat(this.deepClone(tempPrice))

			let tempMonth = [1, 3, 6]
			// for (let number of tempMonth) {
			//   let tempPriceFor = this.deepClone(tempPrice);
			//   let tempMothPrice = tempPriceFor.map((itemData, index) => {
			//     let tempLei = "";
			//     switch (index) {
			//       case 0:
			//         tempLei = "1-2";
			//         break;
			//       case 1:
			//         rate = 10;
			//         tempLei = "3";
			//         break;
			//       case 2:
			//         rate = 10;
			//         tempLei = "4";
			//         break;
			//     }
			//     let rate = 0;
			//     let insuredItem = `${tempLei}类职业（元/${number}个月）`;
			//     switch (number) {
			//       case 1:
			//         rate = 10;
			//         break;
			//       case 3:
			//         rate = 3.3333333333;
			//         break;
			//       case 6:
			//         rate = 1.6666666666;
			//         break;
			//     }
			//     itemData.insuredItem = insuredItem;
			//     for (let i = 1; i <= 8; i++) {
			//       itemData[`plan${i}`] = itemData[`plan${i}`] / rate;
			//     }
			//     return itemData;
			//   });
			//   tempData = tempData.concat(tempMothPrice);
			// }
			this.dataPlan = tempData
		},
		onCellStyle({row, column}) {
			// if (row.$index === 5) {
			//     return {
			//         color: "red"
			//     };
			// }
			if ((row.$index === 4 || row.$index === 10) && column.property != 'plan1') {
				return {
					color: 'red',
				}
			}
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			// if (rowIndex === 5) {
			//     if (columnIndex === 1 || columnIndex === 2) {
			//         return [1, 2];
			//     }
			// }
			if (rowIndex === 2 || rowIndex === 3 || rowIndex === 4 || rowIndex === 10) {
				if (columnIndex === 1) {
					return [1, 11]
				}
			}
		},
		handleInsure() {
			this.$emit('insure')
		},
		handleDownLoad() {
			this.isDownLoading = true
			let fileName = `qh_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
		onChangePriceRate(value) {
			if (this.priceRate !== value) {
				this.priceRate = value
			}
			this.dealPrice()
		},
		onChangeKuozhanRate(value) {
			if (this.kuozhanRate !== value) {
				this.kuozhanRate = value
			}
			this.dealPrice()
		},
	},
}
</script>

<style lang="scss" scoped>
.red-bold {
	color: red;
	font-weight: bold;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
